import { Inbox } from '@spike/omnichannel-model';
import { ChannelStatus } from './ChannelCard/ChannelCard';

export interface EmailChannelCardContent {
    status: ChannelStatus;
    description: string;
    buttonLabel: string;
}

const SENDER_SOURCE_LABELS = {
    marketing: 'your Email Marketing sender',
    own: 'your Inbox address'
} as const;

/**
 * Derives what the Email (SES) channel card shows from the location's `email_ses` inbox.
 * `settings.senderSource` is absent on backends without CUD-5584, where the address always mirrors
 * the Email Marketing sender — so that is the default label.
 */
export const emailChannelCardContent = (inbox?: Inbox): EmailChannelCardContent => {
    const senderSource = SENDER_SOURCE_LABELS[inbox?.settings.senderSource ?? 'marketing'];

    switch (inbox?.status) {
        case 'active':
            return {
                status: 'connected',
                description: `Client replies go out from ${inbox.fromIdentity} (${senderSource}) and land in your Inbox.`,
                buttonLabel: 'Manage'
            };
        case 'pending':
            return {
                status: 'pending',
                description: `Verifying ${inbox.fromIdentity}. Follow the verification steps to start emailing clients from your Inbox.`,
                buttonLabel: 'Refresh'
            };
        default:
            return {
                status: 'notConnected',
                description:
                    'Reply to client emails from your Inbox using your Email Marketing sender or a dedicated address.',
                buttonLabel: 'Set up'
            };
    }
};
